import React, {Component} from "react";
import {withRouter} from "react-router";
import {translate} from "react-i18next";

class Logo extends Component {
    render() {
        return (
            <div className={'logo pointer'} onClick={() => this.props.history.push("/")}/>
        );
    }
}
export default withRouter(translate('header')(Logo));

